define([
  "jquery"],
function ($) {

  "use strict";

  /**
   * The accordion component used in Blinds.com is 100% CSS using the input[type=radio]
   * element to mimic its visual behavior. However, this CSS approach does not allow
   * the user to close one accordion item once it's opened. To make that work, these
   * few lines of JavaScript are needed.
   */
  $(".bdc-accordion").append("<input type='hidden' class='bdc-accordion-selected' />");
  $(".bdc-accordion-item-radio").on("click", function () {
    var $selectedAccordion = $(this).closest(".bdc-accordion").find(".bdc-accordion-selected");
    var currentChecked = $selectedAccordion.val();
    $selectedAccordion.val($(this).attr("id"));
    if (currentChecked === $(this).attr("id")) {
      $(this).prop("checked", false);
      $selectedAccordion.val("");
    }
  });

});
